import { render, staticRenderFns } from "./ExpeditionB.vue?vue&type=template&id=5876244f&scoped=true&lang=html&"
import script from "./ExpeditionB.vue?vue&type=script&lang=js&"
export * from "./ExpeditionB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876244f",
  null
  
)

export default component.exports